<mat-card-content>
    <h1 *ngIf="hasError" class="center" style="color: lightgray">Failed to Load Users</h1>

<div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
  <mat-form-field appearance="outline">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search users">
  </mat-form-field>
</div>

  
      <table  *ngIf="!hasError" mat-table [dataSource]="users" matSort class="mat-elevation-z8">
        <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> User ID </th>
            <td mat-cell *matCellDef="let user" matTooltip="User ID : {{ user.userName }}"> 
                {{ user.userName }} 
            </td>
        </ng-container>
  
        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let user" matTooltip="Full Name: {{ user.firstName }} {{ user.lastName }}"> 
                {{ user.firstName }} {{ user.lastName }} 
            </td>
        </ng-container>
     <!--   <ng-container matColumnDef="organization">
           
              <span *ngIf="!user.organization?.length">Evidant</span>
              <span *ngIf="user.organization?.length > 0">{{ getOrganizationNames(user) }}</span>
            </td>
          </ng-container>-->
          
          
  
        <ng-container matColumnDef="emailAddress">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let user" matTooltip="Email: {{ user.emailAddress }}"> 
                {{ user.emailAddress }} 
            </td>
        </ng-container>
        
      <!--  <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Role </th>
            <td mat-cell *matCellDef="let user" matTooltip="User Role: {{ getRole(user.userType) }}"> 
                {{ getRole(user.userType) }} 
            </td>
        </ng-container>
        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef> Role </th>
            <td mat-cell *matCellDef="let user" matTooltip="{{ user.userType === 1 ? 'User Role: ' + getRole(user.userType) : '' }}">
              {{ user.userType === 1 ? getRole(user.userType) : '' }}
            </td>
          </ng-container>-->
        
        <ng-container matColumnDef="primaryPhone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Primary Phone </th>
            <td mat-cell *matCellDef="let user" matTooltip="Primary Phone: {{ user.primaryPhone }}"> 
                {{ user.primaryPhone }} 
            </td>
        </ng-container>
        
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let user" matTooltip="Title: {{ user.title }}"> 
                {{ user.title }} 
            </td>
        </ng-container>
        
        <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef> Notes </th>
            <td mat-cell *matCellDef="let user" matTooltip="Notes: {{ user.notes }}">
                {{ user.notes?.slice(0, 10) }}{{ user.notes?.length > 10 ? '...' : '' }}
            </td>
        </ng-container>
        
        <ng-container matColumnDef="createdDateTime">
            <th mat-header-cell *matHeaderCellDef> Created Date </th>
            <td mat-cell *matCellDef="let user" matTooltip="Created Date: {{ datePipe.transform(user.createdDateTime, 'MM/dd/yyyy') }}"> 
                {{ datePipe.transform(user.createdDateTime, 'MM/dd/yyyy') }} 
            </td>
        </ng-container>
        
  <!-- Status Column -->
       <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="status-header"> Status </th>
            <td mat-cell *matCellDef="let user" class="status-cell" matTooltip="Status: {{ getStatus(user.status) }}">
                <span [ngClass]="{ 'warn': user.status === 0, 'active': user.status === 1 }">
                    {{ getStatus(user.status) }}
                </span>
            </td>
        </ng-container>

        <!-- Actions Column -->
        <!-- Actions Column -->
<!-- Actions Column -->
<ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="actions-header center-header" style="width: 150px;"> Actions </th>
    <td mat-cell *matCellDef="let user" class="actions-cell">
      <div class="action-icons-container" style="display: flex; gap: 0px; align-items: left;">
        <!-- View User Icon -->
        <button 
        mat-icon-button 
        *ngIf="organizationId && +organizationId !== 0; else defaultIcon"
        [matTooltip]="getUserRoleTooltip(user)" 
        [ngStyle]="{'color': getUserRoleColor(user)}"
        style="width: 20px; height: 20px;">
        <mat-icon class="small-icon">person</mat-icon>
      </button>
      
      <ng-template #defaultIcon>
        <mat-icon 
          class="small-icon" 
          [matTooltip]="user.userType === 1 ? 'Super Admin' : 'User'"
          [ngClass]="user.userType === 1 ? 'red-icon' : 'grey-icon'">
          person
        </mat-icon>
      </ng-template>
        <!-- Edit User Icon -->
        <button 
            mat-icon-button 
            (click)="openUserDialog(user.userId, user.organization?.length || 0)" 
            matTooltip="Edit User" 
            style="width: 20px; height: 20px;">
          <mat-icon color="primary" class="small-icon">edit</mat-icon>
        </button>
  
        <!-- Duplicate User Icon -->
       <!-- <button 
            mat-icon-button 
            (click)="duplicateUser(user.userId)" 
            matTooltip="Duplicate User" 
            style="width: 20px; height: 20px;">
          <mat-icon color="primary" class="small-icon">content_copy</mat-icon>
        </button>-->
        <button 
        mat-icon-button 
        (click)="userChangePasswordDialog(user.userId,user.userName)" 
        matTooltip="Change User Password" 
        style="width: 20px; height: 20px;">
      <mat-icon color="primary" class="small-icon">lock</mat-icon>
    </button>
      
        <!-- Delete User Icon -->
        <button 
            mat-icon-button 
            (click)="deleteUser(user.userId)" 
            matTooltip="Delete User" 
            [disabled]="role !== 1" 
            style="width: 20px; height: 20px;">
          <mat-icon class="small-icon"
              [ngClass]="role === 1 ? 'red-icon' : 'grey-icon'">
            delete_forever
          </mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  
        
       


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let user; columns: displayedColumns;"></tr>
    </table>
 <mat-paginator
  [length]="users.data.length"
  [pageSize]="5"
  [pageSizeOptions]="[5, 10, 25, 100]"
  showFirstLastButtons>
</mat-paginator>
</mat-card-content>
